import React from 'react'
import clsx from 'clsx'

interface TabItem {
  key: string
  label: string
}

interface TabBarProps {
  tabs: TabItem[]
  activeTab: string
  onChange: (key: string) => void
  variant?: 'underline' | 'green'
  className?: string
}

export default function TabBar({ tabs, activeTab, onChange, variant = 'underline', className }: TabBarProps) {
  if (variant === 'green') {
    return (
      <div className={clsx('flex bg-primary rounded-btn p-1 gap-1', className)}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={clsx(
              'flex-1 py-2 px-3 rounded-btn text-xs font-semibold transition-all duration-200',
              activeTab === tab.key
                ? 'bg-white text-primary'
                : 'text-white/70 hover:text-white'
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className={clsx('flex border-b border-gray-200 bg-white', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={clsx(
            'flex-1 py-3 text-sm font-semibold transition-all duration-200 relative',
            activeTab === tab.key
              ? 'text-primary'
              : 'text-text-secondary hover:text-text-primary'
          )}
        >
          {tab.label}
          {activeTab === tab.key && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
          )}
        </button>
      ))}
    </div>
  )
}
